<template>
  <v-card color="#FFFBDA">
    <v-container>
      <div class="my-4 text-h5 font-weight-bold">生命徵象月報表匯出</div>

      <!-- 日期範圍選擇 -->
      <div class="my-2 text-h6 font-weight-bold blue--text">選擇日期範圍</div>
      <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            dense
            outlined
            v-model="formattedDateRange"
            readonly
            v-bind="attrs"
            v-on="on"
            hide-details="true"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="dateRange"
          range
          locale="zh-TW"
          @update:modelValue="handleDateSelection"
        ></v-date-picker>
      </v-menu>

      <!-- 機構選擇 -->
      <div class="my-2 text-h6 font-weight-bold blue--text">選擇機構</div>
      <v-select
        dense
        outlined
        v-model="selectedInstitution"
        :items="institutionOptions"
        hide-details="true"
      ></v-select>

      <!-- 個案選擇（依機構過濾）-->
      <div class="my-2 text-h6 font-weight-bold blue--text">選擇個案</div>
      <v-autocomplete
        dense
        outlined
        v-model="selectedCases"
        :items="filteredCaseOptions"
        item-text="name"
        item-value="case_num"
        multiple
        chips
        deletable-chips
        clearable
        :loading="loading"
        :disabled="loading"
        no-data-text="無"
        hide-details="true"
      >
        <template v-slot:selection="{ item }">
          <v-chip
            class="white--text"
            color="#6A80B9"
            close
            @click:close="removeChip(item.case_num)"
          >
            {{ item.name }}
          </v-chip>
        </template>
      </v-autocomplete>

      <v-btn color="#F6C794" class="mt-4 font-weight-bold" @click="exportReport"> 匯出報表 </v-btn>
    </v-container>
  </v-card>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      menu: false,
      dateRange: [],
      selectedCases: [],
      caseOptions: [],
      institutionOptions: [], // 機構列表
      selectedInstitution: '全部', // 預設為「全部」
      loading: false,
      downloading: false,
    }
  },
  computed: {
    formattedDateRange() {
      if (this.dateRange.length === 2) {
        return `${this.dateRange[0]} 至 ${this.dateRange[1]}`
      }
      return ''
    },
    // 根據 selectedInstitution 過濾 caseOptions
    filteredCaseOptions() {
      if (this.selectedInstitution === '全部') {
        return this.caseOptions
      }
      return this.caseOptions.filter((opt) => opt.institution.includes(this.selectedInstitution))
    },
  },
  methods: {
    handleDateSelection(value) {
      this.dateRange = value
      if (this.dateRange.length === 2) {
        setTimeout(() => {
          this.menu = false
        }, 300)
      }
    },
    async fetchCaseOptions() {
      this.loading = true
      try {
        const response = await axios.get('/api/attendance/name_corresponding/')
        // 全部 case 列表
        this.caseOptions = response.data

        // 建立機構列表（Set 去重）
        const instSet = new Set()
        this.caseOptions.forEach((item) => {
          item.institution.forEach((inst) => instSet.add(inst))
        })
        this.institutionOptions = ['全部', ...Array.from(instSet)]
      } catch (error) {
        console.error('Error:', error)
      } finally {
        this.loading = false
      }
    },
    async exportReport() {
      const payloadCases = this.selectedCases.filter((c) => c !== 'all')
      if (!payloadCases.length) {
        alert('請選擇至少一個個案')
        return
      }
      if (this.dateRange.length !== 2) {
        alert('請選擇完整的日期範圍')
        return
      }

      this.downloading = true
      const requestBody = {
        cases: payloadCases,
        start_time: this.dateRange[0],
        end_time: this.dateRange[1],
        timezone: 'Asia/Taipei',
      }
      try {
        const response = await axios.post('/api/attendance/monthly_report/export', requestBody, {
          responseType: 'blob',
        })
        const fileName = `${this.dateRange[0]}_${this.dateRange[1]}_vital_sign.zip`
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(link)
        this.resetSelections()
      } catch (error) {
        console.error('匯出報表失敗:', error)
        alert('匯出失敗，請稍後再試！')
      } finally {
        this.downloading = false
      }
    },
    removeChip(caseNum) {
      this.selectedCases = this.selectedCases.filter((c) => c !== caseNum)
    },
    resetSelections() {
      this.dateRange = []
      this.selectedCases = []
      this.selectedInstitution = '全部'
    },
  },
  mounted() {
    this.fetchCaseOptions()
  },
  watch: {
    selectedCases(newVal, oldVal) {
      if (newVal.includes('all') && !oldVal.includes('all')) {
        this.selectedCases = this.caseOptions.map((opt) => opt.case_num)
      }
      if (!newVal.includes('all') && oldVal.includes('all')) {
        this.selectedCases = []
      }
    },
  },
}
</script>
